import { theme } from '@chakra-ui/react';

export const shadows = {
  ...theme.shadows,
  // focus-ring outline style

  // https://www.figma.com/file/DQlQ2OY53yJJ3lVIdrzRAp/New-Brand-Guidelines?node-id=490-7970&t=pSBrOksaAlqCpE5G-0
  xs: '0px 0px 4px rgba(0, 0, 0, 0.48)',
  sm: '0px 0px 4px rgba(0, 0, 0, 0.24)',
  base: '0px 0px 8px rgba(0, 0, 0, 0.24)',
  md: '0px 0px 16px rgba(0, 0, 0, 0.16)',

  // Should remove the below shadow,
  outline: '0 0 0 2px #0073E6',
  settingsAccordion: '0px 0px 4px rgba(0, 0, 0, 0.24)',
};
